import { TNodeProps } from '../types/node';
import { BaseNode } from './BaseNode';
import { StandardHandles } from './StandardHandles';

export const HumanNode = (props: TNodeProps) => {
  return (
    <BaseNode {...props} className="min-w-80">
      <StandardHandles withReverseVerticals />
    </BaseNode>
  );
};
